<template>
    <div class="min-vh-100 d-flex bg justify-content-center align-items-md-center">
        <div class="login-form mt-4 mt-md-0 p-4 bg-white round-unify text-center">
            <img :src="$store.state.space.LogoURL" alt="logo" height="64" />
            <div class="card-body w-100 py-4">
                <div v-if="loading" class="text-center">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                    <p class="mt-2">Retrieving access token...</p>
                </div>

                <div v-else-if="!loading && error" class="alert bg-white d-flex flex-column align-items-center">
                    <p class="pb-0">{{ error.message }}</p>
                    <p>
                        <small>{{ error.details }}</small> <br />
                        <small>Details: {{ error.response }}</small>
                    </p>
                    <!-- Give users a clear recovery path when the OAuth exchange fails. -->
                    <CoButton
                        class="mt-3"
                        variant="primary"
                        :label="$t('labels.backtologin')"
                        @click="$router.push('/login')"
                    />
                </div>

                <div v-else class="alert bg-white d-flex flex-column align-items-center">
                    <p class="pb-0">Access granted.</p>
                    <CoButton
                        variant="primary"
                        :label="$t('labels.getstarted')"
                        class="m-auto"
                        @click="$router.push('/')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { isNil } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import i18n from 'vue-i18n';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';

export default {
    components: {
        CoButton,
    },
    data() {
        return {
            loading: false,
            error: null,

            code: this.$route.query.code,
            state: this.$route.query.state,
        };
    },
    mounted() {
        this.auth();
    },

    methods: {
        auth() {
            this.loading = true;
            this.$store
                .dispatch('authenticateWithOA2Provider', {
                    code: this.code,
                    state: this.state,
                })
                .then(({ isLogin }) => {
                    if (isLogin) {
                        this.commitLogin();
                    } else {
                        this.loading = false;
                        this.continueWithSignup();
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.error = { message: err.message };
                });
        },
        commitLogin() {
            this.$store
                .dispatch('getMe')
                .then((response) => {
                    this.$root.$data.$me = response.data;
                    this.$router.replace('/');
                })
                .catch((error) => {
                    this.error = { message: error.message };
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        continueWithSignup() {
            if (!isNil(this.$store.state.newMembership.Plan)) {
                //  continue with address
                this.$store.commit('SET_STEP', 3);
                this.$router.push('/registerv2');
            } else {
                // select plan
                this.$router.push('/plans');
            }
        },
    },
};
</script>
